import React, { forwardRef, useState, useEffect } from "react";
import apiService from "apiService";
import Select2 from "react-select";
import Alert from "view/component/Alert";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import "react-datepicker/dist/react-datepicker.css";
import { confirmedAlert } from "../../component/Alert";
import DatePicker from "react-datepicker";
import moment from "moment";
import Table from "../../component/Table1";
import { E } from "react-select/dist/index-fa0d9f94.esm";
import PrintButton from "../../pendaftaran/module/PrintButton";

const History = (props) => {
  const [refImmunizationVisit, setRefImmunizationVisit] = useState([]);
  const [paramedic, setParamedic] = useState([]);
  const [delivery, setDelivery] = useState([]);
  const [facility, setFacility] = useState([]);
  const [job, setJob] = useState([]);
  const [refImmunization, setRefImmunization] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [refFhirImunization, setrefFhirImunization] = useState(null);
  const [histories, setHistories] = useState({
    immunization_id: null,
    ref_immunization_id: null,
    ref_fhir_id: null,
    patient_id: props.patient.patient_id,
    field_name: null,
    field_date: moment().format("YYYY-MM-DD"),
    status_gizi: null,
    medical_facilities_other_paramedic_type_id: null,
    delivery_method_id: null,
    medical_facilities_other_health_facility_id: null,
    age_day: 0,
    formula: null,
    mp_asi: null,
    nasi: null,
    asi_exclusive: null,
  });

  const [historiesMulti, setHistoriesMulti] = useState([
    {
      immunization_id: null,
      ref_immunization_id: null,
      ref_fhir_id: null,
      patient_id: props.patient.patient_id,
      field_name: null,
      field_date: moment().format("YYYY-MM-DD"),
      status_gizi: null,
      medical_facilities_other_paramedic_type_id: null,
      delivery_method_id: null,
      medical_facilities_other_health_facility_id: null,
      age_day: 0,
      formula: null,
      mp_asi: null,
      nasi: null,
      asi_exclusive: null,
      lot_number: "",
      dosage: "",
    },
  ]);

  const [param, setParam] = useState({
    id: null,
    visit_id: props.patient.id,
    pob: "",
    father_name: "",
    father_job_id: null,
    mother_name: "",
    mother_job_id: null,
    birth_weight: 0,
    birth_height: 0,
    child_order: 1,
    asi: 0,
    time_drinking_asi: 0,
    lot_number: "",
    dosage: "",
  });
  const [vpar, setvpar] = useState({
    id: null,
    visit_id: props.patient.id,
    pob: "",
    father_name: "",
    father_job_id: null,
    mother_name: "",
    mother_job_id: null,
    birth_weight: 0,
    birth_height: 0,
    child_order: 1,
    asi: 0,
    time_drinking_asi: 0,
    lot_number: "",
    dosage: "",
  });

  useEffect(() => {
    getImmunizationByVisit()
  }, [])

  const getImmunizationByVisit = async () => {
    let res = await apiService.get(`/registration/immunizations/search?visit_id=${props.patient.id}`);
    if (res && res.code === 200) {
      setvpar({
        ...vpar,
        id: res.data.id,
        pob: res.data.pob,
        father_name: res.data.father_name,
        father_job_id: res.data.father_job_id,
        father_jobs: {
          value: res.data.father_job_id,
          label: res.data.father_job?.name,
        },
        mother_name: res.data.mother_name,
        mother_job_id: res.data.mother_job_id,
        mother_jobs: {
          value: res.data.mother_job_id,
          label: res.data.mother_job?.name,
        },
        birth_weight: res.data.birth_weight,
        birth_height: res.data.birth_height,
        child_order: res.data.child_order,
        asi: res.data.asi,
        time_drinking_asi: 0,
      })
    }
  }

  const getImmunization = async () => {
    // const age = moment(histories.field_date).diff(
    //   moment(props.patient.patients.birth_date),
    //   "months"
    // );
    var a = moment();
    var b = moment(props.patient.patients.birth_date);

    let age = Math.floor(a.diff(b, "months"));

    let res = await apiService.get(
      "/registration/immunization_record/read?patient_id=" +
      props.patient.patient_id
    );
    if (res && res.code === 200) {
      await setHistories({
        ...histories,
        medical_facilities_other_paramedic_type_id:
          res.data[0]?.medical_facilities_other_paramedic_type_id,
        paramedics: {
          value: res.data[0]?.medical_facilities_other_paramedic_type_id,
          label: res.data[0]?.medical_facilities_other_paramedic_type?.name,
        },
        delivery_method_id: res.data[0]?.delivery_method_id,
        deliveries: {
          value: res.data[0]?.delivery_method_id,
          label: res.data[0]?.delivery_method?.name,
        },
        age_day: age,
        medical_facilities_other_health_facility_id:
          res.data[0]?.medical_facilities_other_health_facility_id,
        medical_facilities: {
          value: res.data[0]?.medical_facilities_other_health_facility_id,
          label: res.data[0]?.medical_facilities_other_health_facility?.name,
        },
        ref_immunization: null,
      });
      setParam(res.data[0].immunization)
      await setRefImmunizationVisit(res.data);
      await getRefImmunization(res.data);
    } else {
      getRefImmunization([]);
    }
  };

  const getStatusGizi = async () => {
    var a = moment();
    var b = moment(props.patient.patients.birth_date);

    let age = Math.floor(a.diff(b, "months"));

    let res = await apiService.get(
      `management/line_graph/search?type=bbu&sex=${props.patient.patients.sex}&month=${age}&value=${props.patient.examinations[0].weight}`
    );
    if (res && res.code === 200) {
      setHistories({
        ...histories,
        status_gizi: res.data,
        status_gizis: {
          value: res.data,
          label: res.data[0].toUpperCase() + res.data.slice(1),
        },
      });
    }
  };

  const getDelivery = async () => {
    let res = await apiService.get("/management/deliveries/read");
    if (res && res.code === 200) {
      setDelivery(res.data);
    }
  };

  const getParamedic = async () => {
    let res = await apiService.get("/management/paramedic_types/read");
    if (res && res.code === 200) {
      setParamedic(res.data);
    }
  };

  const getRefImmunization = async (da) => {
    var im = [];
    var s;
    let res = await apiService.get("/management/immunizations/read");
    if (res && res.code === 200) {
      res.data.map((data) => {
        s = da.find(
          (element) => element.ref_immunization_id === data.id && !element.log
        );
        if (!s) im.push(data);
      });

      setRefImmunization(im);
    }
  };

  const getJob = async () => {
    let res = await apiService.get("/management/jobs/read");
    if (res && res.code === 200) {
      setJob(res.data);
    }
  };

  const getFacility = async () => {
    let res = await apiService.get("/management/health_facilities/read");
    if (res && res.code === 200) {
      setFacility(res.data);
    }
  };

  useEffect(() => {
    getImmunization();
  }, [modalShow]);

  useEffect(() => {
    getDelivery();
    getParamedic();
    getFacility();
    getJob();
    getStatusGizi();
  }, []);

  const postParam = async () => {
    let res;
    let pr = { ...param, visit_id: props.patient.id };
    if (vpar.id) {
      res = await apiService.put("/registration/immunizations/update", pr);
    } else {
      res = await apiService.post("/registration/immunizations/create", pr);
    }

    if (res.code === 200) {
      postHistory(res.data.id);
    } else {
      Alert("error", "gagal menyimpan data");
    }
  };
  const delet = (k) => {
    let data = [...historiesMulti];
    data = [...data.slice(0, k), ...data.slice(k + 1)];
    setHistoriesMulti(data);
  };

  const postHistory = async (id) => {
    let res = await apiService.post("/registration/immunization_record/create_multiple", {
      data: historiesMulti.map(v => ({
        ...v,
        immunization_id: id,
        status_gizi: histories.status_gizi,
        medical_facilities_other_paramedic_type_id: histories.medical_facilities_other_paramedic_type_id,
        delivery_method_id: histories.delivery_method_id,
        medical_facilities_other_health_facility_id: histories.medical_facilities_other_health_facility_id,
        age_day: histories.age_day,
        formula: histories.formula,
        mp_asi: histories.mp_asi,
        nasi: histories.nasi,
        asi_exclusive: histories.asi_exclusive,
      }))
    });
    if (res.code === 200) {
      Alert("success", "data disimpan");
      setModalShow(false);
      historiesMulti.forEach(v => {
        apiService.post(`/fhir/satu_sehat/immunization/${props.patient.id}`, {
          id_fhir: v.ref_fhir_id,
        })
      })
    } else {
      Alert("error", "gagal menyimpan data");
    }
    getImmunization();
  };

  const ref = React.createRef();
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
      className="btn btn-outline-secondary text-default m-0 btn-block"
      ref={ref}
      type="button"
      onClick={onClick}
    >
      {value}
    </button>
  ));

  const createButtonDelete = (datad) => {
    return (
      <button
        onClick={(e) => {
          confirmedAlert(
            "Konfirmasi",
            "Apakah anda akan menghapus data riwayat kehamilan?",
            function (confirmed) {
              if (confirmed) {
                delHistory(datad);
              }
            }
          );
        }}
        className="btn btn-sm btn-danger"
      >
        <span className="btn-inner--icon">
          <i className="fas fa-minus"></i>
        </span>
      </button>
    );
  };

  const createButton = (datad) => {
    return (
      <button
        onClick={(e) => { }}
        className="btn btn-sm btn-secondary text-primary"
      >
        <span className="btn-inner--icon">
          <i className="fas fa-print"></i>
        </span>
      </button>
    );
  };

  const delHistory = async (dataid) => {
    let res = await apiService.delete(
      "/registration/immunization_record/delete/" + dataid
    );
    if (res.code === 200) {
      Alert("success", "data dihapus");
    } else {
      Alert("error", "gagal menghapus data");
    }
    getImmunization();
  };

  return (
    <>
      <div className="card mt-4">
        <div className="card-header bg-success text-white">
          Riwayat Pemeriksaan Anak
        </div>
        <div className="card-header">
          <Table
            className="table table-responsive"
            headers={[
              "No",
              "Menu",
              "Tanggal",
              "Umur Bayi",
              "Imunisasi",
              "BBL",
              "PBL",
              "Berat Badan",
              "Suhu",
              "Pernafasan",
              "Status Gizi",
              "ASI Eksklusif",
              "Pemberian Makanan",
              "Diagnosa",
              "Diagnosa Kebidanan",
              "Bidan",
            ]}
            data={refImmunizationVisit}
            columnMapper={(datas, key) => [
              datas.log ? (
                <span className="btn btn-sm btn-block btn-outline-danger">
                  DELETED
                </span>
              ) : (
                <>
                  {createButton(datas.id)}
                  {createButtonDelete(datas.id)}
                </>
              ),
              moment(datas?.field_date).format("DD-MM-YYYY"),
              datas?.age_day + " Bulan",
              datas?.ref_immunization?.code?.toUpperCase() +
              " - " +
              datas?.ref_immunization?.name,
              datas?.immunization?.birth_weight,
              datas?.immunization?.birth_height,
              datas?.immunization?.visit?.examination?.weight,
              datas?.immunization?.visit?.examination?.temperature,
              datas?.immunization?.visit?.examination?.respiration,
              datas.status_gizi,
              datas.asi_exclusive,
              <>
                <div>{datas?.immunization?.asi}</div>
                <div>{datas.formula}</div>
                <div>{datas.mp_asi}</div>
                <div>{datas.nasi}</div>
              </>,
              datas.immunization?.visit?.diagnoses?.map((data, i) => (
                <div key={i}>{data.icd_code + "-" + data.icd_name}</div>
              )),
              datas?.immunization?.visit?.anamneses[0]?.anamnese,
              datas?.immunization?.visit?.paramedic?.name,
            ]}
            issearch={false}
            pagination={false}
          />
        </div>
        <div className="card-footer">
          <div
            className="btn btn-outline-success"
            onClick={() => setModalShow(true)}
          >
            Tambah Data Pemeriksaan
          </div>
          <PrintButton
            url={`/registration/print/imunisasi/${props.patient.id}`}
            color="success"
            buttonText={'Cetak Imunisasi'}
          />
        </div>
      </div>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={() => setModalShow(false)}
        scrollable
        backdrop="static"
      >
        <ModalHeader>
          <ModalTitle id="contained-modal-title-vcenter">
            Tambah Pemeriksaan Anak
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div className="align-items-center">
            <div className="list-group mb-4">
              <div className="list-group-item mt-0 mb-0 text-white bg-gray">
                <div className="h4 text-white">DATA KELAHIRAN</div>
              </div>
              <div className="list-group-item">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-control-label">Tempat Lahir</label>
                      <div className="input-group">
                        <input
                          type="text"
                          value={param.pob}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              pob: e.target.value,
                            })
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-control-label">
                        Penolong Persalinan
                      </label>
                      <div className="input-group">
                        <Select2
                          className="form-control p-0 pt-1"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={histories.paramedics}
                          onChange={(e) =>
                            setHistories({
                              ...histories,
                              medical_facilities_other_paramedic_type_id:
                                e.value,
                              paramedics: e,
                            })
                          }
                          options={paramedic.map((data) => ({
                            value: data.id,
                            label: data.name,
                          }))}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-control-label">
                        Cara Persalinan
                      </label>
                      <div className="input-group">
                        <Select2
                          className="form-control p-0 pt-1"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={histories.deliveries}
                          onChange={(e) =>
                            setHistories({
                              ...histories,
                              delivery_method_id: e.value,
                              deliveries: e,
                            })
                          }
                          options={delivery.map((data) => ({
                            value: data.id,
                            label: data.name,
                          }))}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-control-label">
                        Tempat Persalinan
                      </label>
                      <div className="input-group">
                        <Select2
                          className="form-control p-0 pt-1"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={histories.medical_facilities}
                          onChange={(e) =>
                            setHistories({
                              ...histories,
                              medical_facilities_other_health_facility_id:
                                e.value,
                              medical_facilities: e,
                            })
                          }
                          options={facility.map((data) => ({
                            value: data.id,
                            label: data.name,
                          }))}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-control-label">Nama Ayah</label>
                      <div className="input-group">
                        <input
                          type="text"
                          value={param.father_name}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              father_name: e.target.value,
                            })
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-control-label">
                        Pekerjaan Ayah
                      </label>
                      <div className="input-group">
                        <Select2
                          className="form-control p-0 pt-1"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={param.father_jobs}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              father_job_id: e.value,
                              father_jobs: e,
                            })
                          }
                          options={job.map((data) => ({
                            value: data.id,
                            label: data.name,
                          }))}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-control-label">Nama Ibu</label>
                      <div className="input-group">
                        <input
                          type="text"
                          value={param.mother_name}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              mother_name: e.target.value,
                            })
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-control-label">
                        Pekerjaan Ibu
                      </label>
                      <div className="input-group">
                        <Select2
                          className="form-control p-0 pt-1"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={param.mother_jobs}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              mother_job_id: e.value,
                              mother_jobs: e,
                            })
                          }
                          options={job.map((data) => ({
                            value: data.id,
                            label: data.name,
                          }))}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-control-label">Anak Ke</label>
                      <div className="input-group">
                        <input
                          type="number"
                          value={param.child_order}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              child_order: e.target.value,
                            })
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-control-label">BBL</label>
                      <div className="input-group">
                        <input
                          type="number"
                          value={param.birth_weight}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              birth_weight: e.target.value,
                            })
                          }
                          className="form-control"
                        />
                        <div className="input-group-append">
                          <span className="input-group-text text-default bg-secondary">
                            gram
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-control-label">PBL</label>
                      <div className="input-group">
                        <input
                          type="number"
                          value={param.birth_height}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              birth_height: e.target.value,
                            })
                          }
                          className="form-control"
                        />
                        <div className="input-group-append">
                          <span className="input-group-text text-default bg-secondary">
                            cm
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="list-group-item mt-0 mb-0 text-white bg-gray">
                <div className="h4 text-white">PEMERIKSAAN ANAK</div>
              </div>
              <div className="list-group-item mt-0 mb-0">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-control-label">
                        Umur Bayi Saat Ini
                      </label>
                      <div className="input-group">
                        <input
                          type="number"
                          value={histories.age_day}
                          onChange={(e) =>
                            setHistories({
                              ...histories,
                              age_day: e.target.value,
                            })
                          }
                          className="form-control"
                        />
                        <div className="input-group-append">
                          <span className="input-group-text text-default bg-secondary">
                            Bulan
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-control-label">Status Gizi</label>
                      <div className="input-group">
                        <Select2
                          className="form-control p-0 pt-1"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={histories.status_gizis}
                          onChange={(e) =>
                            setHistories({
                              ...histories,
                              status_gizi: e.value,
                              status_gizis: e,
                            })
                          }
                          options={[
                            {
                              value: "buruk",
                              label: "Buruk",
                            },
                            {
                              value: "kurang",
                              label: "Kurang",
                            },
                            {
                              value: "normal",
                              label: "Normal",
                            },
                            {
                              value: "lebih",
                              label: "Lebih",
                            },
                          ]}
                        />
                        <div className="input-group-append">
                          <button
                            onClick={() =>
                              setHistories({
                                ...histories,
                                status_gizi: null,
                                status_gizis: null,
                              })
                            }
                            className="btn btn-sm btn-danger"
                          >
                            <span className="btn-inner--icon">
                              <i className="ni ni-fat-remove"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-control-label">
                        ASI Eksklusif
                      </label>
                      <div className="input-group">
                        <Select2
                          className="form-control p-0 pt-1"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={histories.asi_exclusives}
                          onChange={(e) =>
                            setHistories({
                              ...histories,
                              asi_exclusive: e.value,
                              asi_exclusives: e,
                            })
                          }
                          options={[
                            {
                              value: "AE 1",
                              label: "AE 1",
                            },
                            {
                              value: "AE 2",
                              label: "AE 2",
                            },
                            {
                              value: "AE 3",
                              label: "AE 3",
                            },
                            {
                              value: "AE 4",
                              label: "AE 4",
                            },
                            {
                              value: "AE 5",
                              label: "AE 5",
                            },
                            {
                              value: "AE 6",
                              label: "AE 6",
                            },
                          ]}
                        />
                        <div className="input-group-append">
                          <button
                            onClick={() =>
                              setHistories({
                                ...histories,
                                asi_exclusive: null,
                                asi_exclusives: null,
                              })
                            }
                            className="btn btn-sm btn-danger"
                          >
                            <span className="btn-inner--icon">
                              <i className="ni ni-fat-remove"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="form-control-label">
                        Pemberian Makanan Saat Ini
                      </label>
                      <div className="form-control mb-2">
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck1"
                            value="asi"
                            onChange={(e) => {
                              setParam({
                                ...param,
                                asi: e.target.value,
                              });
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheck1"
                          >
                            ASI
                          </label>
                        </div>
                      </div>
                      <div className="form-control mb-2">
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck2"
                            value="formula"
                            onChange={(e) => {
                              setHistories({
                                ...histories,
                                formula: e.target.value,
                              });
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheck2"
                          >
                            Formula
                          </label>
                        </div>
                      </div>
                      <div className="form-control mb-2">
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck3"
                            value="mp_asi"
                            onChange={(e) => {
                              setHistories({
                                ...histories,
                                mp_asi: e.target.value,
                              });
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheck3"
                          >
                            MP ASI
                          </label>
                        </div>
                      </div>
                      <div className="form-control">
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck4"
                            value="nasi"
                            onChange={(e) => {
                              setHistories({
                                ...histories,
                                nasi: e.target.value,
                              });
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheck4"
                          >
                            Nasi/Menu Dewasa
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-control-label">
                        Jenis Imunisasi
                      </label>
                      <div className="input-group">
                        <Select2
                          className="form-control p-0 pt-1"
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={histories.ref_immunization}
                          onChange={(e) =>
                            setHistories({
                              ...histories,
                              ref_immunization_id: e.value,
                              field_name: e.label,
                              ref_immunization: e,
                            })
                          }
                          options={refImmunization.map((data) => ({
                            value: data.id,
                            label: `${data.name} (${data.age_min}-${data.age_max} Bulan)`,
                          }))}
                        />
                        <div className="input-group-append">
                          <button
                            onClick={() =>
                              setHistories({
                                ...histories,
                                ref_immunization: null,
                                field_name: null,
                                ref_immunization_id: null,
                              })
                            }
                            className="btn btn-sm btn-danger"
                          >
                            <span className="btn-inner--icon">
                              <i className="ni ni-fat-remove"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {historiesMulti.map((a, k) => (
                    <div className="col-md-12 row">
                      <div className="col-md-11 row">
                        <div className="col-md-4" key={k}>
                          <div className="form-group">
                            <label className="form-control-label">
                              Jenis Imunisasi
                            </label>
                            <div className="input-group">
                              <Select2
                                className="form-control p-0 pt-1"
                                styles={{
                                  control: (styles) => ({
                                    ...styles,
                                    backgroundColor: "white",
                                    border: "none",
                                  }),
                                }}
                                value={a.ref_immunization}
                                onChange={(e) => {
                                  let h = [...historiesMulti]
                                  h[k] = {
                                    ...h[k],
                                    ref_immunization_id: e.value,
                                    field_name: e.label,
                                    ref_immunization: e,
                                  }
                                  setHistoriesMulti(h)

                                  setrefFhirImunization({
                                    ...refFhirImunization,
                                    [e.value]: {
                                      ref: refImmunization.find(
                                        (a) => a.id == e.value
                                      ).children,
                                      value: null,
                                    },
                                  });
                                }}
                                options={refImmunization.map((data) => ({
                                  value: data.id,
                                  label: `${data.name} (${data.age_min}-${data.age_max} Bulan)`,
                                }))}
                              />
                              <div className="input-group-append">
                                <button
                                  onClick={() => {
                                    let h = [...historiesMulti]

                                    setrefFhirImunization({
                                      ...refFhirImunization,
                                      [h[k].ref_immunization_id]: {
                                        ref: [],
                                        value: null,
                                      },
                                    })

                                    h[k] = {
                                      ...h[k],
                                      ref_immunization: null,
                                      field_name: null,
                                      ref_immunization_id: null,
                                      ref_fhir_id: null,
                                    }
                                    setHistoriesMulti(h)
                                  }}
                                  className="btn btn-sm btn-danger"
                                >
                                  <span className="btn-inner--icon">
                                    <i className="ni ni-fat-remove"></i>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-8" key={k}>
                          <div className="form-group">
                            <label className="form-control-label">
                              detail vaksin
                            </label>
                            <div className="input-group">
                              <Select2
                                className="form-control p-0 pt-1"
                                styles={{
                                  control: (styles) => ({
                                    ...styles,
                                    backgroundColor: "white",
                                    border: "none",
                                  }),
                                }}
                                value={
                                  refFhirImunization?.[
                                    a.ref_immunization_id
                                  ]?.value
                                }
                                onChange={(e) => {
                                  let h = [...historiesMulti]
                                  h[k].ref_fhir_id = e.value
                                  setHistoriesMulti(h)

                                  setrefFhirImunization({
                                    ...refFhirImunization,
                                    [a.ref_immunization_id]: {
                                      ...refFhirImunization?.[a.ref_immunization_id],
                                      value: e,
                                    },
                                  });
                                }}
                                options={refFhirImunization?.[
                                  a.ref_immunization_id
                                ]?.ref?.map((data) => ({
                                  value: data.id,
                                  label: `${data.name}`,
                                }))}
                              />
                              {/* <div className="input-group-append">
                                <button
                                  onClick={() =>
                                    setHistories({
                                      ...histories,
                                      ref_immunization: null,
                                      field_name: null,
                                      ref_immunization_id: null,
                                    })
                                  }
                                  className="btn btn-sm btn-danger"
                                >
                                  <span className="btn-inner--icon">
                                    <i className="ni ni-fat-remove"></i>
                                  </span>
                                </button>
                              </div> */}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="form-control-label">
                              Umur (Bulan)
                            </label>
                            <div className="input-group">
                              <Select2
                                className="form-control p-0 pt-1"
                                styles={{
                                  control: (styles) => ({
                                    ...styles,
                                    backgroundColor: "white",
                                    border: "none",
                                  }),
                                }}
                                value={a.field_months}
                                onChange={(e) => {
                                  let h = [...historiesMulti]
                                  h[k] = {
                                    ...a,
                                    field_month: e.value,
                                    field_months: e,
                                  }
                                  setHistoriesMulti(h)
                                }}
                                options={Array.apply(null, Array(36)).map(
                                  (_, data) => ({
                                    value: data,
                                    label: data,
                                  })
                                )}
                              />
                              <div className="input-group-append">
                                <button
                                  onClick={() => {
                                    let h = [...historiesMulti]
                                    h[k] = {
                                      ...a,
                                      field_month: null,
                                      field_months: null,
                                    }
                                    setHistoriesMulti(h)
                                  }}
                                  className="btn btn-sm btn-danger"
                                >
                                  <span className="btn-inner--icon">
                                    <i className="ni ni-fat-remove"></i>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="form-control-label">
                              Tanggal Imunisasi
                            </label>
                            <div className="input-group">
                              <div className="form-control p-0">
                                <DatePicker
                                  value={a.field_date}
                                  onChange={(e) => {
                                    let h = [...historiesMulti]
                                    h[k] = { ...a, field_date: moment(e).format("YYYY-MM-DD") }
                                    setHistoriesMulti(h)
                                  }}
                                  dateFormat="YYYY-MM-DD"
                                  customInput={<ExampleCustomInput ref={ref} />}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-control-label">Dosis</label>
                            <div className="input-group">
                              <input
                                type="number"
                                value={a.dosage}
                                onChange={(e) => {
                                  let h = [...historiesMulti]
                                  h[k] = { ...a, dosage: e.target.value }
                                  setHistoriesMulti(h)
                                }}
                                className="form-control"
                              />
                              <div className="input-group-append">
                                <span className="input-group-text text-default bg-secondary">
                                  ml
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-control-label">
                              Lot Number
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                value={a.lot_number}
                                onChange={(e) => {
                                  let h = [...historiesMulti]
                                  h[k] = { ...a, lot_number: e.target.value }
                                  setHistoriesMulti(h)
                                }}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-1 ">
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => delet(k)}
                        >
                          del
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() =>
                    setHistoriesMulti([
                      ...historiesMulti,
                      {
                        immunization_id: null,
                        ref_immunization_id: null,
                        ref_fhir_id: null,
                        patient_id: props.patient.patient_id,
                        field_name: null,
                        field_date: moment().format("YYYY-MM-DD"),
                        status_gizi: historiesMulti[0]
                          ? historiesMulti[0].status_gizi
                          : null,
                        medical_facilities_other_paramedic_type_id:
                          historiesMulti[0]
                            ? historiesMulti[0]
                              .medical_facilities_other_health_facility_id
                            : null,
                        delivery_method_id: historiesMulti[0]
                          ? historiesMulti[0].delivery_method_id
                          : null,
                        medical_facilities_other_health_facility_id:
                          historiesMulti[0]
                            ? historiesMulti[0]
                              ?.medical_facilities_other_paramedic_type_id
                            : null,
                        age_day: historiesMulti[0]
                          ? historiesMulti[0]?.age_day
                          : 0,
                        formula: historiesMulti[0]
                          ? historiesMulti[0].formula
                          : null,
                        mp_asi: historiesMulti[0]
                          ? historiesMulti[0].mp_asi
                          : null,
                        nasi: historiesMulti[0] ? historiesMulti[0].nasi : null,
                        asi_exclusive: historiesMulti[0]
                          ? historiesMulti[0].asi_exclusive
                          : null,
                      },
                    ])
                  }
                >
                  add
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="btn btn-success" onClick={() => postParam()}>
            Simpan Pemeriksaan Anak
          </div>
          <div
            className="btn btn-outline-default"
            onClick={() => setModalShow(false)}
          >
            Tutup
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default History;
